<template>
	<v-container class="pa-1">

    <v-snackbar v-model="alerta.activo" multi-line :vertical="true" top right :color="alerta.color" > 
      <strong> {{alerta.texto}} </strong>
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text @click="alerta.activo = false" v-bind="attrs"> Cerrar </v-btn>
      </template>
    </v-snackbar>

    <v-card-actions>
      <div class="font-weight-black text-md-h6 text-xs-subtitle-1 "> Historial del pedido {{ parametros.iddocum }}  </div>
      <v-spacer></v-spacer>
      <v-btn color="error" fab small elevation="1" @click="$emit('modal',false)" ><v-icon>clear</v-icon></v-btn>
    </v-card-actions>

    <v-container style="height: 300px;" v-if="Loading">
      <loading/>
    </v-container>

    <v-row>
      <v-col cols="12">
        <v-timeline dense align-top>
          <v-timeline-item icon="mdi-gift-open-outline" color="orange" fill-dot >
            <v-card>
              <v-card-title class="font-weight-bold subtitle-1"> {{ asignacionMaquilador.titulo }} </v-card-title>
              <v-card-subtitle> 
                Fecha: {{ moment(asignacionMaquilador.asignacion_maquilador).format('LLLL') }} <br>
                Bodega:  {{ asignacionMaquilador.bodega  }} <br>
                Maquilador: {{ asignacionMaquilador.maquilador }}
              </v-card-subtitle>
              <v-footer> {{ asignacionMaquilador.obs_asignacion_maquilador }}</v-footer>
            </v-card>
          </v-timeline-item>

          <v-timeline-item icon="mdi-account-hard-hat" color="orange lighten-2" fill-dot v-if="comienzoMaquilacion.activo">
            <v-card>
              <v-card-title class="font-weight-bold subtitle-1"> {{ comienzoMaquilacion.titulo }} </v-card-title>
              <v-card-subtitle> 
                Fecha: {{ moment(comienzoMaquilacion.comienzo_maquilacion).format('LLLL') }} 
              </v-card-subtitle>
              <v-footer> {{ comienzoMaquilacion.obs_comienzo_maquilacion }}</v-footer>
            </v-card>
          </v-timeline-item>
          
          <v-timeline-item icon="mdi-gift-outline"  color="orange lighten-3" fill-dot v-if="terminaMaquilacion.activo">
            <v-card>
              <v-card-title class="font-weight-bold subtitle-1"> {{ terminaMaquilacion.titulo }} </v-card-title>
              <v-card-subtitle> 
                Fecha: {{ moment(terminaMaquilacion.termina_maquilacion).format('LLLL') }} 
              </v-card-subtitle>
              <v-footer> {{ terminaMaquilacion.obs_termina_maquilacion }}</v-footer>
            </v-card>
          </v-timeline-item>

          <v-timeline-item icon="mdi-bike" color="blue" fill-dot v-if="asignacionRepartidor.activo">
            <v-card>
              <v-card-title class="font-weight-bold subtitle-1"> {{ asignacionRepartidor.titulo }} </v-card-title>
              <v-card-subtitle> 
                Fecha: {{ moment(asignacionRepartidor.asignacion_repartidor).format('LLLL') }} <br>
                Repartidor:  {{ asignacionRepartidor.repartidor  }} 
              </v-card-subtitle>
              <v-footer> {{ asignacionRepartidor.obs_asignacion_repartidor }}</v-footer>
            </v-card>
          </v-timeline-item>
          
          <v-timeline-item icon="mdi-bike-fast" color="cyan" fill-dot v-if="porEntregar.activo">
            <v-card>
              <v-card-title class="font-weight-bold subtitle-1"> {{ porEntregar.titulo }} </v-card-title>
              <v-card-subtitle> 
                Fecha: {{ moment(porEntregar.por_entregar).format('LLLL') }}
              </v-card-subtitle>
              <v-footer> {{ porEntregar.obs_por_entregar }}</v-footer>
            </v-card>
          </v-timeline-item>

          <v-timeline-item icon="mdi-lock-alert" color="red" fill-dot v-if="retenido.es_retenido">
            <v-card>
              <v-card-title class="font-weight-bold subtitle-1"> {{ retenido.titulo }} </v-card-title>
              <v-card-subtitle> 
                Fecha: {{ moment(retenido.retenido).format('LLLL') }}
              </v-card-subtitle>
              <v-footer> {{ retenido.obs_retenido }}</v-footer>
            </v-card>
          </v-timeline-item>

          <v-timeline-item icon="mdi-emoticon-devil-outline" color="success" fill-dot v-if="entregado.activo">
            <v-card>
              <v-card-title class="font-weight-bold subtitle-1"> {{ entregado.titulo }} </v-card-title>
              <v-card-subtitle> 
                Fecha: {{ moment(entregado.entregado).format('LLLL') }}
              </v-card-subtitle>

              <v-card class="elevation-0 pa-0" v-if="historial.imagenes.length">
                <v-card-title class="font-weight-bold subtitle-1" > Evidencias del repartidor </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" lg="3" md="4" sm="4"  
                      v-for="(image, index) in historial.imagenes" :key="index"
                    >
                      <v-hover v-slot="{ hover }" >
                        <v-avatar
                          size="120"
                          :tile="true"
                          @click="openModal(image)"
                          class=""
                        >
                          <v-card  height="100%" >
                            <v-img
                              :src="url + image.image_name"
                              :alt="'Image ' + (index + 1)"
                              @mouseleave="showIcon = false"
                              @mouseover="showIcon = true"
                            >
                              <v-expand-transition>
                                <div
                                  v-if="hover"
                                  class="d-flex transition-fast-in-fast-out purple darken-2 v-card--reveal text-h2 white--text"
                                  style="height: 100%;"
                                >
                                  <v-btn text dark fab> <v-icon> mdi-eye</v-icon></v-btn>
                                </div>
                              </v-expand-transition>

                            </v-img>
                          </v-card>

                        </v-avatar>
                          
                      </v-hover>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
              <v-footer> {{ entregado.obs_entregado }}</v-footer>
            </v-card>
          </v-timeline-item>

        </v-timeline>

      </v-col>


    
    </v-row>

    <div class="mt-6"></div>
    <v-card class="text-center shadowCard pa-3 error headline font-weight-black" dark v-if="parametros.estatus == 4"> 
      PEDIDO RETENIDO 
    </v-card>

    <v-footer absolute v-if="parametros.estatus != 4">
      <v-progress-linear 
        v-model="progreso"
        height="25"
        dark
        rounded 
        color="success"         
      >
        <strong>{{ Math.ceil(progreso) }}%</strong>
      </v-progress-linear>
    </v-footer>

        <!-- Aquí se muestra la modal -->
    <v-dialog v-model="modalImagen" max-width="800px">
      <v-card class="pa-4" height="100%">
        <v-card-actions>
          <div class="font-weight-black text-md-h6 text-xs-subtitle-1 "> Visualizador  </div>
          <v-spacer></v-spacer>
          <v-btn color="error" fab small elevation="1" @click="modalImagen = false" ><v-icon>clear</v-icon></v-btn>
        </v-card-actions>
        <v-img :src="selectedImage" contain></v-img>
      </v-card>
    </v-dialog>
  
    <v-dialog v-model="modalValidarAsignacion" persistent width="500">
      <v-card>
        <v-card-title class="subtitle-1 font-weight-black " style="word-break:normal;">¿ESTÁS SEGURO DE QUERER ASIGNAR EL PEDIDO ? </v-card-title>
        <v-divider class="my-0 py-3" ></v-divider>
        <v-card-subtitle align="center" class="red--text font-weight-bold "> UNA VEZ ATENDIDA NO PODRÁ EDITARSE </v-card-subtitle>
        <v-divider class="my-0 py-2 " ></v-divider>
        <v-card-actions>
          <v-btn color="error" dark @click="modalValidarAsignacion=false" >  NO, Cancelar </v-btn>
          <v-spacer/>
          <v-btn color="primary" text @click="asignarPedidoAMaquilador()" >  SÍ, Asignar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

		<overlay v-if="overlay"/>
  </v-container>
</template>

<script>
  import  metodos from '@/mixins/metodos.js';
	import {mapGetters, mapActions} from 'vuex'
  import loading from '@/components/loading.vue'
  import overlay from '@/components/overlay.vue'

  export default {
    mixins:[metodos],
	  components: {
			loading,
      overlay
		},
		props:[
			'parametros',
	  ],

    data(){
      return{
        Loading: false,
        historial: [],
        eventos:[],
        ObjectDefault:{},
        alerta: { activo: false, texto:'', color:'error' },
        overlay: false,

        obs_asignacion_maquilador: '',

        modalValidarAsignacion: false, 

        asignacionMaquilador:{},
        comienzoMaquilacion:{},
        terminaMaquilacion:{},
        asignacionRepartidor:{},
        porEntregar:{},
        retenido:{},
        entregado:{},

        progreso:0,
        procesos :[0,17,34,50,67,84,100, 666],

        url: this.$http.options.root + 'fotos-epic-grass/' ,
        showIcon: false,
        modalImagen: false,
        selectedImage: null,

      }
    },

    created(){
				this.initialize();
        // this.$http.options.root + 'fotos-epic-grass//'
		},

    watch:{
			parametros(){
				this.initialize();
			},
    },
			
		computed:{
			// IMPORTANDO USO DE VUEX - CLIENTES (GETTERS)
      ...mapGetters('Login',['getusuarioFetish']),
		},

    watch: {
      parametros(){
        this.consultar_historial_pedido()
      }
    },

    methods:{
      
      async initialize(){
        this.consultar_historial_pedido();
      },

      consultar_historial_pedido(){
        this.Loading = true;
        const payload = {
          idpedidos: this.parametros.iddocum
        }

        this.$http.post('obtener.historial.pedido', payload).then( response =>{
          this.historial = response.body
          this.separarDatos();
        }).catch( error =>{
          console.log('error', error);
          this.alerta = { activo: true, color:'error', texto: error.message };
        }).finally(()=>{ 
          this.Loading = false
        })

      },
      
      separarDatos() {
        let data = [];// Solo estamos usando el primer elemento
        data = this.historial.length ? this.historial[0] : [] ; 
        this.historial = this.historial[0];
        // console.log('data', data);
        this.asignacionMaquilador = {
              titulo: 'Se asigna pedido a maquilador',
              asignacion_maquilador: data.asignacion_maquilador,
              obs_asignacion_maquilador: data.obs_asignacion_maquilador,
              bodega: data.bodega,
              maquilador: data.maquilador
        }

        this.comienzoMaquilacion = {
              titulo: 'Se comienza a maquilar',
              comienzo_maquilacion: data.comienzo_maquilacion,
              obs_comienzo_maquilacion: data.obs_comienzo_maquilacion,
              activo: data.comienzo_maquilacion == null ? false: true
        }

        this.terminaMaquilacion = {
          titulo: 'Maquilador termina la preparación',
          termina_maquilacion: data.termina_maquilacion,
          obs_termina_maquilacion: data.obs_termina_maquilacion,
          activo: data.termina_maquilacion == null ? false: true
        }

        this.asignacionRepartidor = {
          titulo: 'Se asigna pedido a repartidor',
          asignacion_repartidor: data.asignacion_repartidor,
          obs_asignacion_repartidor: data.obs_asignacion_repartidor,
          repartidor: data.repartidor,
          activo: data.asignacion_repartidor == null ? false: true
        }

        this.porEntregar = {
          titulo: 'El pedido esta por entregarse',
          por_entregar: data.por_entregar,
          obs_por_entregar: data.obs_por_entregar,
          activo: data.por_entregar == null ? false: true
        }

        this.retenido = {
          titulo: 'El producto fue retenido',
          retenido: data.retenido,
          obs_retenido: data.obs_retenido,
          es_retenido: data.es_retenido,
          activo: data.retenido == null ? false: true
 
        }

        this.entregado = {
          titulo: 'El producto fue entregado con exito',
          entregado: data.entregado,
          obs_entregado: data.obs_entregado,
          activo: data.entregado == null ? false: true
        }

        this.progreso = this.procesos[data.proceso];
      },

      openModal(image) {
        // console.log('image', image);
        this.selectedImage = this.url + image.image_name;
        this.modalImagen = true;
      },
    } 
  }
</script>

<style>
  .v-card--reveal {
    align-items: center;
    bottom: 0;
    justify-content: center;
    opacity: .8;
    position: absolute;
    width: 100%;
  }
</style>